/**
 * 端外flowPond相关参数的处理逻辑
 */
import { getClickId, getChannel } from './get-clickId'
import { getQueryofKey, getQueryString } from '../../utils/getUrlParams'
import { setParamsInCookies } from './set-cookie'
import { getCuid } from './cuid'
import yikeSellLog from '../../node_modules/@imp/package/lib/zyb-yike-utils/yikeSellLog'
import { checkLastfrom } from './check-param'
// 获取当前链接上的所有参数
const urlParams: any = getQueryString()
const lastfrom: string = urlParams['lastfrom']
/**
 * flowPond初始化
 * 端外flowPond参数初始化方法
 */
async function flowPondInit() {
  console.log('flowPond-init-start')
  const clickId = await getClickId()
  // 将关键参数设置进主域名cookie备份
  if (clickId) {
    setParamsInCookies(clickId)
  }
  const cuid = getCuid()
  console.log('当前clickId为：', clickId)
  // qdPage 数据使用的一个维度参数，用来看数
  const qdPage = window.location.pathname.replace(/\/static\/hy\//g, '')
  // 获取广告ID
  const qdAdId = getAdId()
  // 获取创意ID
  const qdCreativeId = getCreativeId()
  // 获取联盟站点
  const qdUnionSite = getUnionSite()
  // 获取oppo渠道下使用的bid参数
  const qdOppoLbid = getOppoLbId()
  // 神马渠道下获取convname
  const qdSmConvName = getSmConvName()
  const currentChannel = getChannel()
  const appId = urlParams['appId'] || urlParams['appid']
  const fObj: any = {
    qdPage,
    lastfrom,
    i: cuid,
  }
  if (clickId) {
    // clickId在落地页跳转到地址页后，可能只存在链接flowPond里，链接上没有这个参数，这个时候，不应覆盖
    fObj.clickId = clickId
  }
  if (qdAdId) {
    fObj.qdAdId = qdAdId
    if (currentChannel == 'pyq') {
      fObj.qdAdgroupId = qdAdId
    }
  }
  if (qdCreativeId) {
    fObj.qdCreativeId = qdCreativeId
  }
  if (qdUnionSite) {
    fObj.qdUnionSite = qdUnionSite
  }
  if (qdOppoLbid) {
    fObj.qdOppoLbid = qdOppoLbid
  }
  if (qdSmConvName) {
    fObj.qdSmConvName = qdSmConvName
  }
  if (appId) {
    fObj.qdWechatAppId = appId
  }
  console.log('fObj')
  console.log('yikeSellLog.getFlowPond', yikeSellLog.getFlowPond())
  console.log('yikeSellLog.getFlowPond', yikeSellLog.getUrlFlowPond())
  yikeSellLog.setFlowPond(fObj)
  checkLastfrom()
}

/**
 * 获取adid
 * 落地页URL中的adid广告id
 */
function getAdId() {
  let qdAdId = ''
  const channel = getChannel()
  if (channel === 'oppo') {
    qdAdId = getQueryofKey('pageId')
  }
  if (channel === 'pyq') {
    qdAdId =
      getQueryofKey('wx_aid') ||
      (getQueryofKey('weixinadinfo') || '').toString().split('.')[0]
  }
  if (channel === 'jrtt') {
    qdAdId = getQueryofKey('adid')
  }
  return qdAdId
}

/**
 * 获取creativeid
 * 落地页URL中的creativeid创意id
 */
function getCreativeId() {
  let qdCreativeId = ''
  const channel = getChannel()
  if (channel === 'jrtt') {
    qdCreativeId = getQueryofKey('creativeid')
  }
  return qdCreativeId
}

/**
 * 获取unionSite
 * 落地页URL中的union_site联盟站点
 */
function getUnionSite() {
  let qdUnionSite = ''
  const channel = getChannel()
  if (channel === 'jrtt') {
    qdUnionSite = getQueryofKey('union_site')
  }
  return qdUnionSite
}

/**
 * 获取oppo渠道落地页lbid
 */
function getOppoLbId() {
  let qdOppoLbid = ''
  const channel = getChannel()
  if (channel === 'oppo') {
    qdOppoLbid = getQueryofKey('lbid')
  }
  return qdOppoLbid
}

/**
 * 获取convname
 * 落地页URL中的convname转化名称
 */
function getSmConvName() {
  let qdSmConvName = ''
  const channel = getChannel()
  if (channel === 'sm') {
    qdSmConvName = getQueryofKey('convname')
  }
  return qdSmConvName
}

const getParamInFlowPond = (param: any): any => {
  let result: string = ''
  if (!param) return result
  let fp = yikeSellLog.getUrlFlowPond()
  try {
    result = JSON.parse(decodeURIComponent(fp))[param]
  } catch (err) {
    console.log(`解析flowPond中的${param}失败`, err)
  }
  return result || ''
}

const getReservedUrlFlowPond = (): any => {
  let flowPond: any = {}
  let fp = yikeSellLog.getUrlFlowPond()
  try {
    flowPond = JSON.parse(decodeURIComponent(fp))
  } catch (err) {
    console.log(`解析flowPond失败: ${fp}`, err)
  }

  let ret: any = {}
  let exist = false
  const reservedKeys = ['fissionId', 'afxActId']
  reservedKeys.forEach((key: any) => {
    if (flowPond.hasOwnProperty(key)) {
      ret[key] = flowPond[key]
      exist = true
    }
  })

  return exist ? encodeURIComponent(JSON.stringify(ret)) : ''
}

export { flowPondInit, getParamInFlowPond, getReservedUrlFlowPond }
